export const APP_PRODUCT_NAME = 'Client Correspondence and Submittal Portal';
export const APP_SUBTITLE = 'Construction Correspondence & Submittal Management';

export const COMPANY_NAME = 'D.E.C Infrastructure & Projects (India) Private Limited';
export const DEC_INFRA = 'DEC Infra';
export const COMPANY_LOGO = '/is-logo.png';

export const POWERED_BY_NAME = 'Nutrinium Technologies';
export const POWERED_BY_LOGO = '/nutrinium-logo.png';
